// extracted by mini-css-extract-plugin
export default {"personalizedABDWrapper":"vi8K5cugoDBDImKIr3NI","personalizedABDIcon":"NuR_AoEgmJMDs8nRjebe"};